import { css } from "lit";

export const styles = css`
  :host {
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  svg {
    border-radius: 50%;
  }
`;
